<template>
  <div>
    <div class="mt-component-form">
      <vs-row class="my-4">
        <vs-col
          ><h5><i class="dot"></i>기본정보</h5></vs-col
        >
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">회사명</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_1 }}</p>
          <ml-input
            v-else
            v-model="form.inputA_1"
            class="w-full flex-1"
            :readonly="true"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">소속</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_0 }}</p>
          <ml-input
            v-else
            class="w-full flex-1"
            v-model="form.inputA_0"
            :readonly="true"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">부서</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_2 }}</p>
          <ml-input
            v-else
            v-model="form.inputA_2"
            class="w-full flex-1"
            :readonly="true"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">작성자</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_3 }}</p>
          <ml-input
            v-else
            v-model="form.inputA_3"
            class="w-full flex-1"
            :readonly="true"
          />
        </div>
      </div>
    </div>
    <div class="mt-component-form">
      <vs-row class="my-4">
        <vs-col
          ><h5><i class="dot"></i>관련내용</h5></vs-col
        >
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">신청부서</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputB_1 }}</p>
          <company-selector
            v-else
            v-model="form.inputB_1"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 col-start-1 flex items-center ">
          <div class="label-text mr-4">직위</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputB_2 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputB_2"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">성명</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputB_3 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputB_3"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-8 flex items-center">
          <div class="label-text mr-4">사업명(장소)</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputB_4 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputB_4"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-8 flex items-center">
          <div class="label-text mr-4">작업의 종류</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputB_5 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputB_5"
            class="w-full flex-1"
          />
        </div>
        <div class=" col-span-4 col-start-1 flex items-center">
          <div class="label-text mr-4">작업중지 일자</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputB_6 }}</p>
          <date-selector
            :readonly="board.readonly"
            v-else
            v-model="form.inputB_6"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">작업중지 시간</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputB_7 }}</p>
          <time-selector v-else v-model="form.inputB_7" class="w-full flex-1" />
        </div>
        <div class="col-span-12 flex items-start">
          <div class="label-text mr-4 mt-2">
            작업중지 사유 (원인 및 예상피해 기술)
          </div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputB_8 }}</p>
          <ml-textarea
            :readonly="board.readonly"
            v-else
            v-model="form.inputB_8"
            class="flex-1 w-full"
            rows="5"

          />
        </div>
        <div class="col-span-12 flex items-start">
          <div class="label-text mr-4 mt-2">
            조치사항
          </div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputB_9 }}</p>
          <ml-textarea
            :readonly="board.readonly"
            v-else
            v-model="form.inputB_9"
            class="flex-1 w-full"
            rows="5"

          />
        </div>
        <div class="col-span-12 flex items-start">
          <div class="label-text mr-4 mt-2">
            향후 계획
          </div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputB_10 }}</p>
          <ml-textarea
            :readonly="board.readonly"
            v-else
            v-model="form.inputB_10"
            class="flex-1 w-full"
            rows="5"

          />
        </div>
      </div>
    </div>
    <div class="mt-component-form">
      <vs-row class="my-4">
        <vs-col
          ><h5><i class="dot"></i>관련사진</h5></vs-col
        >
      </vs-row>
      <div class="grid grid-cols-12 h-upload">
        <div class="col-span-6 upload-content">
          <div class="upload-content__file">
            <file-uploader
              v-if="!isPrint"
              type="only-image"
              v-model="form.inputC_1"
            />
            <img class="w-full h-full" v-else :src="form.inputC_1.thumb" />
          </div>
          <div class="upload-content__input">
            <p v-if="isPrint" class="w-full flex-1">{{ form.inputC_3 }}</p>
            <ml-input
              :readonly="board.readonly"
              v-else
              v-model="form.inputC_3"
              class="w-full "
            />
          </div>
        </div>
        <div class="col-span-6 upload-content">
          <div class="upload-content__file">
            <FileUploader
              class="w-full h-full"
              v-if="!isPrint"
              type="only-image"
              v-model="form.inputC_2"
            />
            <img class="w-full h-full" v-else :src="form.inputC_2.thumb" />
          </div>
          <div class="upload-content__input">
            <p v-if="isPrint" class="w-full flex-1">{{ form.inputC_4 }}</p>
            <ml-input
              :readonly="board.readonly"
              v-else
              v-model="form.inputC_4"
              class="w-full "
            />
          </div>
        </div>
      </div>
    </div>
    <file-upload-module
      :readonly="board.readonly"
      v-if="!isPrint"
      class="mt-component-form w-full "
      v-model="form.fileList"
    />
  </div>
</template>

<script>
import DateSelector from "@/components/selector/DateSelector.vue";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector.vue";
import FileUploader from "@/components/FileUploader.vue";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import CompanySelector from '@/components/selector/CompanySelector'
export default {
  components: {
    CompanySelector,
    DateSelector,
    DisasterClassSelector,
    FileUploadModule,
    FileUploader,
    TimeSelector
  },
  name: "Write",
  props: {
    board: Object,
    value: Object,
    isPrint: {
      type: Boolean
    }
  },
  watch: {
    board: {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.inputA_1 =
          this.value && this.value.inputA_1
            ? this.value.inputA_1
            : this.board.projectTitle;
        this.form.inputA_2 =
          this.value && this.value.inputA_2
            ? this.value.inputA_2
            : this.board.writer.com_name;
        this.form.inputA_3 =
          this.value && this.value.inputA_3
            ? this.value.inputA_3
            : this.board.writer.name;
        this.form.inputA_0 =
          this.value && this.value.inputA_0
            ? this.value.inputA_0
            : this.board.writer.department;
      }
    },
    value(value) {
      const keys = Object.keys(this.form);
      for (const key of keys) {
        this.form[key] = value[key];
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = value.inputA_1;
        value.summary = {
          "그룹": [{ '공단임직원': 1 }],
        }
        this.$emit("input", value);
      }
    }
  },
  data() {
    return {
      form: {
        fileList: [],
        inputA_0: "",
        inputA_1: "",
        inputA_2: "",
        inputA_3: "",

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",
        inputB_7: "",
        inputB_8: "",
        inputB_9: "",
        inputB_10: "",

        inputC_1: {},
        inputC_2: {},
        inputC_3: "",
        inputC_4: ""
      }
    };
  }
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
